import { combineReducers, Reducer } from 'redux';
import { reducer as manufacturerReducer } from 'b2b-apps/shop/manufacturer/redux/manufacturer/reducer';
import { reducer as manufacturersReducer } from 'b2b-apps/shop/manufacturer/redux/manufacturers/reducer';
import { ManufacturerActions, ManufacturerState } from './types';

const reducer: Reducer<ManufacturerState, ManufacturerActions> = combineReducers({
  manufacturer: manufacturerReducer,
  manufacturers: manufacturersReducer,
});

export { reducer };
